import { createContext } from '@chakra-ui/react-utils';
import { ReactNode, useMemo, useState } from 'react';

interface NavbarContextProviderValue {
  activeKey: string;
  setActiveKey: (newKey: string) => void;
}

const [NavbarContextProvider, useNavbarContext] =
  createContext<NavbarContextProviderValue>({
    name: 'NavbarContext',
  });

const defaultKey = '';

interface NavbarProviderProps {
  children: ReactNode;
}

const NavbarProvider = (props: NavbarProviderProps) => {
  const [activeKey, setActiveKey] = useState(defaultKey);

  const value = useMemo(
    () => ({
      activeKey,
      setActiveKey: (newKey: string) =>
        setActiveKey((prevKey) => (prevKey !== newKey ? newKey : defaultKey)),
    }),
    [activeKey],
  );

  return <NavbarContextProvider {...props} value={value} />;
};

export { NavbarProvider, useNavbarContext };
